__turbopack_context__.v({
  "button": "custom-skeleton-module-scss-module__P5sYdG__button",
  "button-secondary": "custom-skeleton-module-scss-module__P5sYdG__button-secondary",
  "circle": "custom-skeleton-module-scss-module__P5sYdG__circle",
  "image": "custom-skeleton-module-scss-module__P5sYdG__image",
  "pulse": "custom-skeleton-module-scss-module__P5sYdG__pulse",
  "shimmer": "custom-skeleton-module-scss-module__P5sYdG__shimmer",
  "text": "custom-skeleton-module-scss-module__P5sYdG__text",
  "transform": "custom-skeleton-module-scss-module__P5sYdG__transform",
});
